import { render, staticRenderFns } from "./DeleteMapViewDialog.vue?vue&type=template&id=2bcb96bb"
import script from "./DeleteMapViewDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMapViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports